/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type PedestrianDevice,
    PedestrianDeviceFromJSON,
    PedestrianDeviceToJSON,
} from '../models/PedestrianDevice';
import {
    type PedestrianDeviceCreate,
    PedestrianDeviceCreateFromJSON,
    PedestrianDeviceCreateToJSON,
} from '../models/PedestrianDeviceCreate';
import {
    type PedestrianDeviceSortKey,
    PedestrianDeviceSortKeyFromJSON,
    PedestrianDeviceSortKeyToJSON,
} from '../models/PedestrianDeviceSortKey';
import {
    type PedestrianDeviceUpdate,
    PedestrianDeviceUpdateFromJSON,
    PedestrianDeviceUpdateToJSON,
} from '../models/PedestrianDeviceUpdate';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface RoutesPedestrianDevicesCreatePedestrianDeviceRequest {
    pedestrianDeviceCreate: PedestrianDeviceCreate;
}

export interface RoutesPedestrianDevicesListPedestrianDevicesRequest {
    pageSize: number;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: PedestrianDeviceSortKey;
}

export interface RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest {
    pageSize: number;
    search?: string | null;
}

export interface RoutesPedestrianDevicesReadPedestrianDeviceRequest {
    pedestrianDeviceId: string;
}

export interface RoutesPedestrianDevicesUpdatePedestrianDeviceRequest {
    pedestrianDeviceId: string;
    pedestrianDeviceUpdate: PedestrianDeviceUpdate;
}

export interface RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest {
    pedestrianDeviceCreate: PedestrianDeviceCreate;
}

export interface RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest {
    pedestrianDeviceId: string;
    pedestrianDeviceUpdate: PedestrianDeviceUpdate;
}

/**
 * PedestrianDevicesApi - interface
 * 
 * @export
 * @interface PedestrianDevicesApiInterface
 */
export interface PedestrianDevicesApiInterface {
    /**
     * Creates request options for routesPedestrianDevicesCreatePedestrianDevice without sending the request
     * @param {PedestrianDeviceCreate} pedestrianDeviceCreate 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesCreatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesCreatePedestrianDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new pedestrian device.
     * @summary Create a pedestrian device
     * @param {PedestrianDeviceCreate} pedestrianDeviceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesCreatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PedestrianDevice>>;

    /**
     * Create a new pedestrian device.
     * Create a pedestrian device
     */
    routesPedestrianDevicesCreatePedestrianDevice(requestParameters: RoutesPedestrianDevicesCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PedestrianDevice>;

    /**
     * Creates request options for routesPedestrianDevicesListPedestrianDevices without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PedestrianDeviceSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesListPedestrianDevicesRequestOpts(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the pedestrian devices present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List pedestrian devices
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PedestrianDeviceSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesListPedestrianDevicesRaw(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PedestrianDevice>>>;

    /**
     * Lists all the pedestrian devices present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List pedestrian devices
     */
    routesPedestrianDevicesListPedestrianDevices(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PedestrianDevice>>;

    /**
     * Creates request options for routesPedestrianDevicesListPedestrianDevicesMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesListPedestrianDevicesMetadataRequestOpts(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary pedestrian device listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesListPedestrianDevicesMetadataRaw(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * pedestrian device listing metadata
     */
    routesPedestrianDevicesListPedestrianDevicesMetadata(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for routesPedestrianDevicesReadPedestrianDevice without sending the request
     * @param {string} pedestrianDeviceId 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesReadPedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesReadPedestrianDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the pedestrian device specified by the given ID.
     * @summary Get a single pedestrian device
     * @param {string} pedestrianDeviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesReadPedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesReadPedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PedestrianDevice>>;

    /**
     * Returns the pedestrian device specified by the given ID.
     * Get a single pedestrian device
     */
    routesPedestrianDevicesReadPedestrianDevice(requestParameters: RoutesPedestrianDevicesReadPedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PedestrianDevice>;

    /**
     * Creates request options for routesPedestrianDevicesUpdatePedestrianDevice without sending the request
     * @param {string} pedestrianDeviceId 
     * @param {PedestrianDeviceUpdate} pedestrianDeviceUpdate 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesUpdatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesUpdatePedestrianDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the pedestrian device specified by the given ID.
     * @summary Update pedestrian device
     * @param {string} pedestrianDeviceId 
     * @param {PedestrianDeviceUpdate} pedestrianDeviceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesUpdatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PedestrianDevice>>;

    /**
     * Update the pedestrian device specified by the given ID.
     * Update pedestrian device
     */
    routesPedestrianDevicesUpdatePedestrianDevice(requestParameters: RoutesPedestrianDevicesUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PedestrianDevice>;

    /**
     * Creates request options for routesPedestrianDevicesValidateCreatePedestrianDevice without sending the request
     * @param {PedestrianDeviceCreate} pedestrianDeviceCreate 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesValidateCreatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new pedestrian device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a pedestrian device
     * @param {PedestrianDeviceCreate} pedestrianDeviceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesValidateCreatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new pedestrian device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a pedestrian device
     */
    routesPedestrianDevicesValidateCreatePedestrianDevice(requestParameters: RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for routesPedestrianDevicesValidateUpdatePedestrianDevice without sending the request
     * @param {string} pedestrianDeviceId 
     * @param {PedestrianDeviceUpdate} pedestrianDeviceUpdate 
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesValidateUpdatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given pedestrian device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate pedestrian device update
     * @param {string} pedestrianDeviceId 
     * @param {PedestrianDeviceUpdate} pedestrianDeviceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PedestrianDevicesApiInterface
     */
    routesPedestrianDevicesValidateUpdatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given pedestrian device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate pedestrian device update
     */
    routesPedestrianDevicesValidateUpdatePedestrianDevice(requestParameters: RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PedestrianDevicesApi extends runtime.BaseAPI implements PedestrianDevicesApiInterface {

    /**
     * Creates request options for routesPedestrianDevicesCreatePedestrianDevice without sending the request
     */
    async routesPedestrianDevicesCreatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesCreatePedestrianDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pedestrianDeviceCreate'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceCreate',
                'Required parameter "pedestrianDeviceCreate" was null or undefined when calling routesPedestrianDevicesCreatePedestrianDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PedestrianDeviceCreateToJSON(requestParameters['pedestrianDeviceCreate']),
        };
    }

    /**
     * Create a new pedestrian device.
     * Create a pedestrian device
     */
    async routesPedestrianDevicesCreatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PedestrianDevice>> {
        const requestOptions = await this.routesPedestrianDevicesCreatePedestrianDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PedestrianDeviceFromJSON(jsonValue));
    }

    /**
     * Create a new pedestrian device.
     * Create a pedestrian device
     */
    async routesPedestrianDevicesCreatePedestrianDevice(requestParameters: RoutesPedestrianDevicesCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PedestrianDevice> {
        const response = await this.routesPedestrianDevicesCreatePedestrianDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesPedestrianDevicesListPedestrianDevices without sending the request
     */
    async routesPedestrianDevicesListPedestrianDevicesRequestOpts(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling routesPedestrianDevicesListPedestrianDevices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the pedestrian devices present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List pedestrian devices
     */
    async routesPedestrianDevicesListPedestrianDevicesRaw(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PedestrianDevice>>> {
        const requestOptions = await this.routesPedestrianDevicesListPedestrianDevicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PedestrianDeviceFromJSON));
    }

    /**
     * Lists all the pedestrian devices present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List pedestrian devices
     */
    async routesPedestrianDevicesListPedestrianDevices(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PedestrianDevice>> {
        const response = await this.routesPedestrianDevicesListPedestrianDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesPedestrianDevicesListPedestrianDevicesMetadata without sending the request
     */
    async routesPedestrianDevicesListPedestrianDevicesMetadataRequestOpts(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling routesPedestrianDevicesListPedestrianDevicesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * pedestrian device listing metadata
     */
    async routesPedestrianDevicesListPedestrianDevicesMetadataRaw(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.routesPedestrianDevicesListPedestrianDevicesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * pedestrian device listing metadata
     */
    async routesPedestrianDevicesListPedestrianDevicesMetadata(requestParameters: RoutesPedestrianDevicesListPedestrianDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.routesPedestrianDevicesListPedestrianDevicesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesPedestrianDevicesReadPedestrianDevice without sending the request
     */
    async routesPedestrianDevicesReadPedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesReadPedestrianDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pedestrianDeviceId'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceId',
                'Required parameter "pedestrianDeviceId" was null or undefined when calling routesPedestrianDevicesReadPedestrianDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/{pedestrian_device_id}`;
        urlPath = urlPath.replace('{pedestrian_device_id}', encodeURIComponent(String(requestParameters['pedestrianDeviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the pedestrian device specified by the given ID.
     * Get a single pedestrian device
     */
    async routesPedestrianDevicesReadPedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesReadPedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PedestrianDevice>> {
        const requestOptions = await this.routesPedestrianDevicesReadPedestrianDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PedestrianDeviceFromJSON(jsonValue));
    }

    /**
     * Returns the pedestrian device specified by the given ID.
     * Get a single pedestrian device
     */
    async routesPedestrianDevicesReadPedestrianDevice(requestParameters: RoutesPedestrianDevicesReadPedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PedestrianDevice> {
        const response = await this.routesPedestrianDevicesReadPedestrianDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesPedestrianDevicesUpdatePedestrianDevice without sending the request
     */
    async routesPedestrianDevicesUpdatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesUpdatePedestrianDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pedestrianDeviceId'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceId',
                'Required parameter "pedestrianDeviceId" was null or undefined when calling routesPedestrianDevicesUpdatePedestrianDevice().'
            );
        }

        if (requestParameters['pedestrianDeviceUpdate'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceUpdate',
                'Required parameter "pedestrianDeviceUpdate" was null or undefined when calling routesPedestrianDevicesUpdatePedestrianDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/{pedestrian_device_id}`;
        urlPath = urlPath.replace('{pedestrian_device_id}', encodeURIComponent(String(requestParameters['pedestrianDeviceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PedestrianDeviceUpdateToJSON(requestParameters['pedestrianDeviceUpdate']),
        };
    }

    /**
     * Update the pedestrian device specified by the given ID.
     * Update pedestrian device
     */
    async routesPedestrianDevicesUpdatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PedestrianDevice>> {
        const requestOptions = await this.routesPedestrianDevicesUpdatePedestrianDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PedestrianDeviceFromJSON(jsonValue));
    }

    /**
     * Update the pedestrian device specified by the given ID.
     * Update pedestrian device
     */
    async routesPedestrianDevicesUpdatePedestrianDevice(requestParameters: RoutesPedestrianDevicesUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PedestrianDevice> {
        const response = await this.routesPedestrianDevicesUpdatePedestrianDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesPedestrianDevicesValidateCreatePedestrianDevice without sending the request
     */
    async routesPedestrianDevicesValidateCreatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pedestrianDeviceCreate'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceCreate',
                'Required parameter "pedestrianDeviceCreate" was null or undefined when calling routesPedestrianDevicesValidateCreatePedestrianDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PedestrianDeviceCreateToJSON(requestParameters['pedestrianDeviceCreate']),
        };
    }

    /**
     * Validate data for a new pedestrian device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a pedestrian device
     */
    async routesPedestrianDevicesValidateCreatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.routesPedestrianDevicesValidateCreatePedestrianDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new pedestrian device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a pedestrian device
     */
    async routesPedestrianDevicesValidateCreatePedestrianDevice(requestParameters: RoutesPedestrianDevicesValidateCreatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.routesPedestrianDevicesValidateCreatePedestrianDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for routesPedestrianDevicesValidateUpdatePedestrianDevice without sending the request
     */
    async routesPedestrianDevicesValidateUpdatePedestrianDeviceRequestOpts(requestParameters: RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pedestrianDeviceId'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceId',
                'Required parameter "pedestrianDeviceId" was null or undefined when calling routesPedestrianDevicesValidateUpdatePedestrianDevice().'
            );
        }

        if (requestParameters['pedestrianDeviceUpdate'] == null) {
            throw new runtime.RequiredError(
                'pedestrianDeviceUpdate',
                'Required parameter "pedestrianDeviceUpdate" was null or undefined when calling routesPedestrianDevicesValidateUpdatePedestrianDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pedestrian_devices/{pedestrian_device_id}/validate`;
        urlPath = urlPath.replace('{pedestrian_device_id}', encodeURIComponent(String(requestParameters['pedestrianDeviceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PedestrianDeviceUpdateToJSON(requestParameters['pedestrianDeviceUpdate']),
        };
    }

    /**
     * Validate data for updating the given pedestrian device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate pedestrian device update
     */
    async routesPedestrianDevicesValidateUpdatePedestrianDeviceRaw(requestParameters: RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.routesPedestrianDevicesValidateUpdatePedestrianDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given pedestrian device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate pedestrian device update
     */
    async routesPedestrianDevicesValidateUpdatePedestrianDevice(requestParameters: RoutesPedestrianDevicesValidateUpdatePedestrianDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.routesPedestrianDevicesValidateUpdatePedestrianDeviceRaw(requestParameters, initOverrides);
    }

}
